import React from 'react';
import styled from 'styled-components';
import { FaHistory, FaPlay, FaTrashAlt } from 'react-icons/fa';
import { colors } from '../../../../assets/styles/GlobalStyles';
import { Button } from '../../../../components/ui/Button/Button';
import { FormSection } from '../styles/wizardStyles';

const Titulo = styled.h2`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.15rem;
  font-weight: 700;
  color: ${colors.darkBlue};
  margin: 0 0 0.75rem 0;

  svg {
    flex-shrink: 0;
  }
`;

const Texto = styled.p`
  font-size: 0.92rem;
  line-height: 1.5;
  color: ${colors.darkGray};
  margin: 0 0 0.5rem 0;
`;

const Observacao = styled.p`
  font-size: 0.82rem;
  line-height: 1.45;
  color: ${colors.textMuted};
  margin: 0 0 0.5rem 0;
`;

const Botoes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 1.25rem;

  @media (max-width: 480px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
      justify-content: center;
    }
  }
`;

const formatarData = (timestamp) =>
  new Date(timestamp).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });

// Mostrado no lugar do wizard quando a pessoa abre um pedido que deixou pela
// metade. "Continuar" restaura o rascunho; "Descartar" cancela o requerimento
// Pendente (se já tinha sido criado) e começa do zero.
const RetomarPedidoCard = ({ rascunho, etapaDocumentos, loading, onContinuar, onDescartar }) => {
  const parouNosDocumentos = rascunho.currentStep === etapaDocumentos;
  const temBoleto = Boolean(rascunho.pagamento?.tituloData);

  return (
    <FormSection>
      <Titulo>
        <FaHistory aria-hidden="true" />
        Você tem um pedido em andamento
      </Titulo>
      <Texto>
        Você começou este pedido em {formatarData(rascunho.salvoEm)}
        {rascunho.numeroPedido && <> (Nº do Pedido <strong>{rascunho.numeroPedido}</strong>)</>}
        {' '}e não concluiu. Deseja continuar de onde parou?
      </Texto>
      {parouNosDocumentos && (
        <Observacao>Os documentos precisarão ser selecionados novamente.</Observacao>
      )}
      {temBoleto && (
        <Observacao>O boleto/PIX já gerado será mostrado novamente — não é preciso gerar outro.</Observacao>
      )}
      {rascunho.requerimentoId && (
        <Observacao>
          Se descartar, {rascunho.numeroPedido ? `o Nº do Pedido ${rascunho.numeroPedido}` : 'o pedido iniciado'} será cancelado.
        </Observacao>
      )}

      <Botoes>
        <Button variant="secondary" onClick={onDescartar} disabled={loading} leftIcon={<FaTrashAlt />}>
          {loading ? 'Descartando...' : 'Descartar e começar novo'}
        </Button>
        <Button variant="primary" onClick={onContinuar} disabled={loading} leftIcon={<FaPlay />}>
          Continuar pedido
        </Button>
      </Botoes>
    </FormSection>
  );
};

export default RetomarPedidoCard;
